import { render, staticRenderFns } from "./SysPositionList.vue?vue&type=template&id=5955846d&scoped=true&"
import script from "./SysPositionList.vue?vue&type=script&lang=js&"
export * from "./SysPositionList.vue?vue&type=script&lang=js&"
import style0 from "./SysPositionList.vue?vue&type=style&index=0&id=5955846d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955846d",
  null
  
)

export default component.exports